var React = require('react');

function Mouse (props) {
    return React.createElement("svg",props,[React.createElement("path",{"className":"fill-none stroke-background","d":"M8,3.4c-2.2,0-4,1.8-4,4v2v0v2c0,2.2,1.8,4,4,4s4-1.8,4-4v-2v0v-2\n\tC12,5.2,10.2,3.4,8,3.4z","key":0}),React.createElement("path",{"className":"fill-none stroke-foreground","d":"M7.9,5.7C7.4,5.7,7,6,7,6.5V7v0v1.2C7,8.6,7.4,9,7.9,9\n\tc0.5,0,0.9-0.4,0.9-0.9V7v0V6.5C8.8,6,8.4,5.7,7.9,5.7z","key":1})]);
}

Mouse.defaultProps = {"version":"1.0","viewBox":"0 0 16 16","xmlSpace":"preserve"};

module.exports = Mouse;

Mouse.default = Mouse;
